export const GUARD_SYMBOL = Symbol.for('TypeGuard:guard');
